// extracted by mini-css-extract-plugin
export default {"header":"styles_header__8Dzp1","title":"styles_title__g7gsD"};